import { useEffect, useRef, useState } from "react";
import { useAuth } from "../contexts/AuthCtx";
import AuthService from "../api/auth";

const ContactListSection = ({ }) => {

    const authCtx = useAuth();
    const emailRef = useRef(null);

    const [loading, setLoading] = useState(0);  // initial = 0, loading = 1, success = 2, error = 3

    const handleSubmitForm = (e) => {
        //   // setLoading(1);
        e.preventDefault();
        // window.alert("Submitted token :: ", token);
        //   setRefreshReCaptcha(!refreshReCaptcha);
        setLoading(1);
        AuthService.joinNewsletter({
          name: '',
          email: emailRef.current.value
        }, {}).then((r) => {
          if(r && r.status === 200) {
            setLoading(2);
          }
          else
          {
            setLoading(3);
          }
        })
      }

      useEffect(() => {
        if(loading === 2) {
            setTimeout(() => {
                emailRef.current.value = '';
                setLoading(0);
            }, 3000);
        }
        else if(loading === 3) {
          setTimeout(() => {
            setLoading(0);
          }, 3000);
        }
      }, [loading])

    return (
        <>
            <section className="work-section contact-list-section">
                <div className="inner">
                    <div className="col">
                        <h1 className="impact-hdr">Need help?</h1>
                        <p>We would love to help you.</p>
                    </div>
                    <div className="services-container">
                        <div className="service-card small -st">
                            <div className="inner">
                                <div className="label">
                                    <a href="#" className="text-button">Live chat</a>
                                    <p>You can chat with us live on working hours.</p>
                                </div>
                            </div>
                        </div>
                        <div className="service-card small">
                            <div className="inner">
                                <div className="label">
                                    <a href="#" onClick={(e) => {
                                        e.preventDefault();
                                        authCtx.setGetQuote(true);
                                    }} className="text-button">Request a callback</a>
                                    <p>Write us in the contact form and we will be in touch with you.</p>
                                </div>
                            </div>
                        </div>
                        <div className="service-card small">
                            <div className="inner">
                                <div className="label">
                                    <a href="mailto:contact@equibre.com" className="text-button">Send us email</a>
                                    <p>We always responds as fast as we can.</p>
                                </div>
                            </div>
                        </div>
                        <div className="service-card small">
                            <div className="inner">
                                <div className="label">
                                    <a href="https://blog.equibre.com" target="_blank" className="text-button">Visit our blogs</a>
                                    <p>Many peoples found our blogs helpful.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col ns-form">
                        <div>
                            <h1>Join our newsletter</h1>
                        </div>
                        <form onSubmit={handleSubmitForm} className="newsletter-form">
                            <div>
                                <input ref={emailRef} required placeholder="Your email*" type="email" />
                            </div>
                            <div>
                                <button disabled={loading !== 0} type="submit">{loading === 1 ? "Joining..." : loading === 2 ? "Joined, Thank you!" : loading === 3 ? "Failed to submit." : "Join"}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
        </>
    );
}

export default ContactListSection;